import { Button } from 'antd';
import { Link } from 'react-router-dom';
import { CheckCircleOutlined, ExclamationCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';
import logoDLPAY from '../../../assets/images/logo.png';
import './PublicStatusPage.scss';

const VARIANT_ICONS = {
  success: CheckCircleOutlined,
  warning: ExclamationCircleOutlined,
  danger: ExclamationCircleOutlined,
  neutral: InfoCircleOutlined,
};

const PublicStatusPage = ({ variant, heading, body, action, merchantName, title, className, children }) => {
  const VariantIcon = VARIANT_ICONS[variant];
  const rootClassName = className ? `PublicStatusPage ${className}` : 'PublicStatusPage';

  const renderAction = () => {
    if (!action) {
      return null;
    }
    if (action.onClick) {
      return (
        <Button type="primary" className="state-banner-action" onClick={action.onClick}>
          {action.label}
        </Button>
      );
    }
    return (
      <Link to={action.to} className="state-banner-action">
        {action.label}
      </Link>
    );
  };

  return (
    <section className={rootClassName}>
      <header>
        <div className="container-header">
          <div className="navigation">
            <p>{merchantName}</p>
            <img src={logoDLPAY} alt="Logo DLPay Private" />
          </div>
          {title && <h2>{title}</h2>}
        </div>
      </header>
      <div className="content">
        <div className="details-content">
          {heading && (
            <div className={`state-banner state-banner--${variant}`}>
              {VariantIcon && <VariantIcon aria-hidden="true" className="state-banner-icon" />}
              <h3 className="state-banner-heading">{heading}</h3>
              <p className="state-banner-body">{body}</p>
              {renderAction()}
            </div>
          )}
          {children}
        </div>
      </div>
    </section>
  );
};

export default PublicStatusPage;
